



































































import { snakeCase } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import Button, { ButtonStruct } from '../../ButtonsConstructor/buttons'

@Component({
  data() {
    return {
      snakeCase,
    }
  },
  components: {
    ValidationObserver,
  }
})
export default class ButtonSettingsView extends Vue {
  @Prop() struct!: ButtonStruct | null

  @Prop() currentButton!: null | Button

  @Prop({ default: false, type: Boolean }) solo!: boolean

  @Emit()
  back(): void {
    return
  }

  @Emit()
  edit(): void {
    return
  }

  @Emit()
  remove(): void {
    return
  }

  @Emit()
  add(): void {
    return
  }
}
